import { RefreshCwIcon } from 'lucide-react'

import { useReanalyzeAssessmentControls } from '@/api/analyzer.hook'

import { useIsSupportUser } from '@/lib/app/support-user'

import { CONTROLS_TAB_LABELS } from '@/pages/assessment/assessment-tabs/labels'

import { Button } from '@/components/lemmala-design-system/button/button'
import {
  ConfirmResult,
  useConfirmModal,
} from '@/components/lemmala-design-system/modal/use-confirm-modal'
import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'

type ReanalyzeAssessmentControlsButtonProps = {
  assessmentId: string
}

export const ReanalyzeAssessmentControlsButton = ({
  assessmentId,
}: ReanalyzeAssessmentControlsButtonProps) => {
  const isSupportUser = useIsSupportUser()
  const { confirm } = useConfirmModal()
  const { mutateAsync: reanalyzeAssessmentControls, isPending } = useReanalyzeAssessmentControls()

  if (!isSupportUser) return null

  const handleClick = async () => {
    const result = await confirm({
      title: CONTROLS_TAB_LABELS.EVALUATE_ALL_CONTROLS_CONFIRM_TITLE,
      content: CONTROLS_TAB_LABELS.EVALUATE_ALL_CONTROLS_CONFIRM_CONTENT,
      primaryButtonText: CONTROLS_TAB_LABELS.EVALUATE_ALL_CONTROLS_CONFIRM_BUTTON,
    })
    if (result === ConfirmResult.CONFIRMED) {
      await reanalyzeAssessmentControls({ orgOngoingAssessmentId: assessmentId })
    }
  }

  return (
    <Button size={'sm'} variant={'outline'} disabled={isPending} onClick={handleClick}>
      <TextWithIcon
        icon={<RefreshCwIcon size={14} className={isPending ? 'animate-spin' : ''} />}
        text={
          isPending
            ? CONTROLS_TAB_LABELS.EVALUATING_ALL_CONTROLS
            : CONTROLS_TAB_LABELS.EVALUATE_ALL_CONTROLS
        }
      />
    </Button>
  )
}
